import { render, staticRenderFns } from "./sms-parts-table.vue?vue&type=template&id=4c150f4e&"
import script from "./sms-parts-table.vue?vue&type=script&lang=js&"
export * from "./sms-parts-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports